import React from 'react'
import { makeStyles, createStyles, Box, CssBaseline } from '@material-ui/core'
import BottomNavbar from './BottomNavbar'
import MobileThemeProvider from 'src/mobile/themes/MobileThemeProvider'
import { useTranslation } from 'react-i18next'
// import useUserSession from 'src/hooks/useUserSession'
import { useRouteMatch } from 'react-router-dom'
// import { parse } from 'query-string'
import GoToTop from '../components/GoToTop'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper,
    },
  }),
)

const Layout = ({ children }) => {
  const classes = useStyles()
  // const { search } = useLocation()
  const { i18n } = useTranslation()
  // const { authenticated, userInfo } = useUserSession()
  const hideBackTop = useRouteMatch(`/${i18n.language}/signin`) || useRouteMatch(`/${i18n.language}/signup`)

  // useEffect(() => {
  //   const query = parse(search)
  //   if (authenticated && userInfo?.language) {
  //     i18n.changeLanguage(userInfo?.language)
  //   } else if (query?.lang) {
  //     i18n.changeLanguage(query?.lang)
  //   }
  // }, [search, authenticated, userInfo?.language])
  const handleClick = () => {
    scrollToAnchor('main', true)
  }
  const scrollToAnchor = (anchorName, smooth) => {
    if (anchorName) {
      const anchorElement = document.getElementById(anchorName)
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: 'start', behavior: smooth ? 'smooth' : 'auto' })
      }
    }
  }
  return (
    <MobileThemeProvider>
      <CssBaseline />
      <Box className={classes.root} id="main">
        {children}
        <BottomNavbar />
      </Box>
      {!hideBackTop && (
        <Box
          minHeight={30}
          bgcolor="white"
          position="fixed"
          right="30px"
          bottom="80px"
          borderRadius="50%"
          boxShadow="0px 26px 29px rgba(0, 0, 0, 0.04), 0px 12px 24px rgba(0, 0, 0, 0.08), 0px 8px 12px rgba(0, 0, 0, 0.04)"
        >
          {' '}
          <GoToTop _handleClick={handleClick} />
        </Box>
      )}
    </MobileThemeProvider>
  )
}

export default Layout
